import { render, staticRenderFns } from "./EMAnagraficaBarche.vue?vue&type=template&id=ff8a5f1c&scoped=true&"
import script from "./EMAnagraficaBarche.vue?vue&type=script&lang=js&"
export * from "./EMAnagraficaBarche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8a5f1c",
  null
  
)

export default component.exports